import React, {useEffect, useContext} from 'react';
import styled from 'styled-components/macro';
import {PropSheet, PropSheetTitle, TextField, SelectField, TextAreaField, OptionSelect, CheckboxField} from './UI';
import EditorContext from '../../modules/contexts/editor';
import { updateNodeType } from '../../modules/libs/lessonLib';
import {backgroundChoices, styleChoices} from '../../modules/defines/style';
import { pagePaths } from '../../modules/defines/lessondefs';

const pageChoices = [];
Object.getOwnPropertyNames(pagePaths).forEach(l => Object.getOwnPropertyNames(pagePaths[l]).forEach(s => pagePaths[l][s].map(p => pageChoices.push({ label: `${l.replace('Lesson', '')} / ${s} / ${p}`, value: p }))));
pageChoices.sort((i1, i2) => i1.label > i2.label);
// const pageChoices = Object.getOwnPropertyNames(pagePaths).map(l => ({
//     label: l,
//     submenu: Object.getOwnPropertyNames(pagePaths[l]).map(s => ({
//         label: s,
//         submenu: pagePaths[l][s],
//     }))
// }));

const PagePropSheet = ({ node }) => {
    const editor = useContext(EditorContext);

    const onBlur = (field, value) => {
        editor.updateNodeField(node, field, value);
        editor.commitNodeUpdate(node);
    };

    return (
        <PropSheet>
            <PropSheetTitle>Page ({node.nodeID})</PropSheetTitle>
            <TextField label='Title' inputRef={input => { if (input) input.value = node.title; }} onBlur={e => onBlur('title', e.target.value)}  />
            <CheckboxField label="Page contains optional content (show Skip instead of Next button)" checked={Boolean(node.optional)} onChange={e => onBlur('optional', e.target.checked)} />
            <OptionSelect node={node} field={{label: 'Page type', value: node.componentName || 'Default', choices: pageChoices}} onSelect={e => onBlur('componentName', e.target.value)} />
            <OptionSelect node={node} field={{label: 'Background', value: node.background || 'Default', choices: backgroundChoices(node)}} onSelect={e => onBlur('background', e.target.value)} />
            { styleChoices(node) && (
                <OptionSelect node={node} field={{label: 'Style', value: node.style || 'Normal', choices: styleChoices(node)}} onSelect={e => onBlur('style', e.target.value)} />
            )}

        </PropSheet>
    );
};

export default PagePropSheet;
